import { useDateRangeContext } from '@/context/DateRangeContext';
import { useTimedUsage } from '@/hooks/useTimedUsage';

export const TrackAcousticsModeUsage = () => {
    const { isTrackingLive } = useDateRangeContext();
    useTimedUsage('Acoustics mode usage', { mode: isTrackingLive ? 'live' : 'historical' });

    return null;
};
